import { PlaceholdersId, TFComponent } from '@types';

import { ModalsPlaceholder } from './modals';

export const modals: TFComponent = {
	component: ModalsPlaceholder,
	id: PlaceholdersId.modals,
	name: 'modals',
};
